import { render, staticRenderFns } from "./AuthorPreview.vue?vue&type=template&id=a50999de&scoped=true"
import script from "./AuthorPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthorPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AuthorPreview.vue?vue&type=style&index=0&id=a50999de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50999de",
  null
  
)

export default component.exports